//@todo Dit is eigenlijk een soort van code javascript
AddPageSwapTrigger(function () {
    var verify = $('<div />');
    var response = null;
    verify.css('text-align', 'center');
    verify.css('margin', '20px auto');
    verify.html('<div style="text-align: center; display: inline-block;"><div class="g-recaptcha" id="g-recaptcha-down"></div></div>');
    var fncDown = function (el) {
        $(el).find('.badge').text(parseInt($(el).find('.badge').text()) + 1);
        if ($(el).attr('href') == '#') {
            $.post(document.location.href.split('#')[0] + (document.location.href.search(/\?/) != -1 ? '&' : '?') + 'thumbs_down=true', {
                recaptcha: response
            });
        }
        else {
            $.post($(el).attr('href'), {
                recaptcha: response
            });
        }
    }


    $('.thumbs_up').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).find('.badge').text(parseInt($(this).find('.badge').text()) + 1);
        if ($(this).attr('href') == '#') {
            $.get(document.location.href.split('#')[0] + (document.location.href.search(/\?/) != -1 ? '&' : '?') + 'thumbs_up=true');
        }
        else {
            $.get($(this).attr('href'), function() {
                // do nothing
            });
        }
    });



    $('.thumbs_down').click(function (e) { //12thumbd
        var el = this;
        e.preventDefault();
        e.stopPropagation();

        captcha('thumb_down', function(token) {
            response = token;
            fncDown(el);
        });
    });
})


AddPageSwapTrigger(function () {
    function setThumbs(data) {
        for (var i = 0; i < data.length; i++) {
            $('#thumb_up_' + data[i].id).html(data[i].up);
            $('#thumb_down_' + data[i].id).html(data[i].down);
        }
    }
    if ($('.shop_page_thumbs').is('.shop_page_thumbs')) {
        var shop_id = parseInt($('.shop_page_thumbs').data('id'));
        var url = '/live/nationaal-goto/get-thumbs/id/' + shop_id;

        if(fileIsBeingPreloaded(url)) {
            whenJsonIsPreloadedByUrl(url, function (data) {
                var json = JSON.parse(data);
                setThumbs(json);
            });
        }
        else {
            $.get(url, setThumbs, "json");
        }
    }
});